import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { CadastrarPlanejamentoOficinaComponent } from './cadastrar-planejamento-oficina/cadastrar-planejamento-oficina.component';
import { PlanejamentoOficinaRoutingModule } from './planejamento-oficina-routing.module';
import { PlanejamentoOficinaComponent } from './planejamento-oficina.component';


import { MatDialogModule } from "@angular/material/dialog";
import { NgxCurrencyModule } from 'ngx-currency';
import { ComboBeneficiarioModule } from "../common/combo-beneficiario/combo-beneficiario.module";
import { ComboCargoModule } from "../common/combo-cargo/combo-cargo.module";
import { ComboContratoModule } from "../common/combo-contrato/combo-contrato.module";
import { ComboFuncionarioModule } from "../common/combo-funcionario/combo-funcionario.module";
import { ComboMaterialModule } from "../common/combo-material/combo-material.module";
import { ComboMetaAcaoModule } from "../common/combo-meta-acao/combo-meta-acao.module";
import { ComboMetaObjetivoModule } from "../common/combo-meta-objetivo/combo-meta-objetivo.module";
import { ComboObjetivoModule } from "../common/combo-objetivo/combo-objetivo.module";
import { ComboPercursoModule } from "../common/combo-percurso/combo-percurso.module";
import { ComboProgramaModule } from "../common/combo-programa/combo-programa.module";
import { ComboProjetoModule } from "../common/combo-projeto/combo-projeto.module";
import { ComboPublicoAlvoModule } from '../common/combo-publico-alvo/combo-publico-alvo.module';
import { ComboTurmaModule } from '../common/combo-turma/combo-turma.module';
import { DadosFuncionarioModule } from '../common/dados-funcionario/dados-funcionario.module';
import { AcoesPlanejamentoOficinaComponent } from './acoes-planejamento-oficina/acoes-planejamento-oficina.component';
import { CadastrarAcoesPlanejamentoOficinaComponent } from './acoes-planejamento-oficina/cadastrar-acoes/cadastrar-acoes-planejamento-oficina.component';
import { ListarAcoesPlanejamentoOficinaComponent } from './acoes-planejamento-oficina/listar-acoes/listar-acoes-planejamento-oficina.component';
import { DadosPlanejamentoOficinaComponent } from './dados-planejamento-oficina/dados-planejamento-oficina.component';
import { FormularioAcoesExecutadaMetasComponent } from './formulario-acoes-executada-metas/formulario-acoes-executada-metas.component';
import { FormularioAcoesExecutadasColaboradorComponent } from './formulario-acoes-executadas-colaborador/formulario-acoes-executadas-colaborador.component';
import { FormularioAcoesExecutadasFrequenciaComponent } from './formulario-acoes-executadas-frequencia/formulario-acoes-executadas-frequencia.component';
import { FormularioAcoesExecutadasComponent } from './formulario-acoes-executadas/formulario-acoes-executadas.component';
import { FormularioAcoesMetasComponent } from './formulario-acoes-metas/formulario-acoes-metas.component';
import { FormularioObjetivoAtividadeComponent } from './formulario-objetivo-atividade/formulario-objetivo-atividade.component';
import { CadastrarMateriaisComponent } from './materiais-planejamento-oficina/cadastrar-materiais/cadastrar-materiais.component';
import { ListarMateriaisComponent } from './materiais-planejamento-oficina/listar-materiais/listar-materiais.component';
import { MaterialPlanejamentoOficinaComponent } from './materiais-planejamento-oficina/material-planejamento-oficina.component';
import { CadastrarPublicoAlvoPlanejamentoOficinaComponent } from './publico-alvo-planejamento-oficina/cadastrar-publico-alvo-planejamento-oficina/cadastrar-publico-alvo-planejamento-oficina.component';
import { ListarPublicosAlvoPlanejamentoOficinaComponent } from './publico-alvo-planejamento-oficina/listar-publicos-alvos-planejamentos-oficinas/listar-publico-alvo-planejamento-oficina.component';
import { PublicoAlvoPlanejamentoOficinaComponent } from './publico-alvo-planejamento-oficina/publico-alvo-planejamento-oficina.component';
import { CadastrarTurmasPlanejamentoOficinaComponent } from './turmas-planejamento-oficina/cadastrar-turmas/cadastrar-turmas-planejamento-oficina.component';
import { ListarTurmasPlanejamentosOficinasComponent } from './turmas-planejamento-oficina/listar-turmas/listar-turmas-planejamento-oficina.component';
import { TurmaPlanejamentoOficinaComponent } from './turmas-planejamento-oficina/turma-planejamento-oficina.component';


@NgModule({
  declarations: [PlanejamentoOficinaComponent,
                 CadastrarPlanejamentoOficinaComponent,
                 MaterialPlanejamentoOficinaComponent,
                 CadastrarMateriaisComponent,
                 CadastrarTurmasPlanejamentoOficinaComponent,
                 ListarMateriaisComponent,
                 ListarTurmasPlanejamentosOficinasComponent,
                 TurmaPlanejamentoOficinaComponent,
                 DadosPlanejamentoOficinaComponent,
                    PublicoAlvoPlanejamentoOficinaComponent,
                    CadastrarPublicoAlvoPlanejamentoOficinaComponent,
                    ListarPublicosAlvoPlanejamentoOficinaComponent,
                    FormularioObjetivoAtividadeComponent,
                                     AcoesPlanejamentoOficinaComponent,
                                     CadastrarAcoesPlanejamentoOficinaComponent,
                                     ListarAcoesPlanejamentoOficinaComponent,
                    FormularioAcoesExecutadasComponent,
                    FormularioAcoesExecutadasFrequenciaComponent,
                    FormularioAcoesExecutadasColaboradorComponent,
                    FormularioAcoesMetasComponent,
                    FormularioAcoesExecutadaMetasComponent],
    imports: [
        CommonModule,
        PlanejamentoOficinaRoutingModule,
        MaterialCommonModule,
        MatExpansionModule,
        MatTabsModule,
        NgxCurrencyModule,
        DadosFuncionarioModule,
        ComboContratoModule,
        ComboPercursoModule,
        MatDialogModule,
        ComboFuncionarioModule,
        ComboBeneficiarioModule,
        ComboMetaObjetivoModule,
        ComboMetaAcaoModule,
        ComboProjetoModule,
        ComboProgramaModule,
        ComboMaterialModule,
        ComboCargoModule,
        ComboObjetivoModule,
        ComboTurmaModule,
        ComboPublicoAlvoModule
    ]
})
export class PlanejamentoOficinaModule { }
